import { ICrudLocale } from '@app/i18n/interface';

export const USER_MANAGEMENT_LOCALE_EN: ICrudLocale = {
  USER: {
    LABEL: {
      SINGULAR: 'User',
      PLURAL: 'Users',
    },
    FORM: {
      ADD_TITLE: 'Add user',
      EDIT_TITLE: 'Edit user',
      CARD_TITLE: 'User details',
      BACK: 'Back to Users',
      ADD_DESCRIPTION: 'Add a team member and choose their group; the group decides what they can do.',
      EDIT_DESCRIPTION: 'Change this person’s details, group or access.',
      FETCH_DEPENDENCIES_ERROR: 'We could not load the groups. Please try again.',
    },
    FIELD: {
      NAME: 'Name',
      USERNAME: 'Username',
      EMAIL: 'Email',
      GENDER: 'Gender',
      ENABLED: 'Enabled',
      LASTNAME: 'Last name',
      PASSWORD: 'Password',
      MOBILE: 'Mobile',
      ROL: 'Role',
      STATE: 'Status',
      DNI: 'ID',
      GROUPS: 'Groups',
      BIRTHDATE: 'Date of birth',
      SELF_GENERATED_PASSWORD: 'Auto-generated password',
      LAST_LOGIN: 'Last login',
    },
    LIST: {
      DESCRIPTION:
        'Add your team, change their group or disable access for anyone who no longer needs it.',
      ADD: 'Add user',
      DELETED_HIDDEN: 'Deleted users are not shown.',
      DELETED_SHOWN: 'Deleted users are shown too.',
      DELETED_SHOW: 'Show deleted users',
      DELETED_HIDE: 'Hide deleted users',
      DELETED_BADGE: 'Deleted',
      DELETED_ON: 'Deleted on {{date}}',
      SEARCH_PLACEHOLDER: 'Search by name',
      TITLE: 'Team',
      CAPTION: 'Back office users',
      FILTERS: 'Filters',
      EMPTY: 'No team member matches the filter.',
      YOU: 'You',
      NEVER: 'Has not signed in yet',
      ACTIVE: 'Active',
      DISABLED: 'Disabled',
      EDIT: 'Edit',
      EDIT_ARIA: 'Edit {{name}}',
      DISABLE: 'Disable',
      DISABLE_ARIA: 'Disable {{name}}',
      ENABLE: 'Reactivate',
      ENABLE_ARIA: 'Reactivate {{name}}',
      DELETE: 'Delete',
      DELETE_ARIA: 'Delete {{name}}',
      SELF_NOTE: 'This is your account, it cannot be disabled',
      LAST_ADMIN_NOTE: 'This is the last administrator, it cannot be disabled',
      TOGGLE_ERROR: 'We could not change the access. Please try again.',
      HELP: 'To delete someone, disable them first. Disabling closes their access and can be undone. Deleting removes the account and cannot be undone from here. Your account and the last administrator cannot be disabled or deleted.',
    },
    DELETE: {
      TITLE: 'Delete {{name}}?',
      BODY: 'Their account is deleted and this cannot be undone from here. Their name stays in the history of the bookings they handled.',
      HINT: 'If you only want them to stop signing in, leave them disabled.',
      CHECK: 'To confirm, type their email: {{email}}',
      KEEP: 'Keep the user',
      CONFIRM: 'Delete user',
      DONE: '{{name}} has been deleted.',
      ERROR: 'We could not delete {{name}}. Please try again.',
    },
  },
};
